import {
	flexOfficesByLocation,
	useYtaQuery,
	useAuthQuery,
} from '@alexanderathoodly/data-models'
import type {
	LocationResult,
	FlexOfficeResult,
} from '@alexanderathoodly/data-models'
import { useSearchParams } from '~/utils/routing'
import { useLocationPage, useCurrentOffice } from './context'
import { useUser } from 'reactfire'

export type CoworkingSearchParams = {
	workspaces: number | undefined
	budget: number | undefined
}

export function useOfficeSearchParams(): CoworkingSearchParams {
	const params = useSearchParams()
	const workspaces = params.get('ws')
	const budget = params.get('budget')
	return {
		workspaces: workspaces ? Number(workspaces) : undefined,
		budget: budget ? Number(budget) : undefined,
	}
}

interface UseOfficesDisplay {
	location: LocationResult | undefined
	params: CoworkingSearchParams
	error: Error | null
	isError: boolean
	isLoading: boolean
	isIdle: boolean
	currentOffice: FlexOfficeResult | undefined
	offices: FlexOfficeResult[] | undefined
}

export function useOfficesDisplay(): UseOfficesDisplay {
	const { location } = useLocationPage()
	const params = useOfficeSearchParams()

	const { data: user } = useUser()
	const resultWithoutAuth = useYtaQuery(
		flexOfficesByLocation({
			location: location?.id || '',
		})
	)
	const resultWithAuth = useAuthQuery(
		flexOfficesByLocation({
			location: location?.id || '',
		})
	)
	const result = user ? resultWithAuth : resultWithoutAuth
	const { data: offices, error, isError, isLoading, isIdle } = result
	const { currentOffice } = useCurrentOffice()

	return {
		location,
		params,
		error: error as Error,
		isError: isError,
		isLoading: isLoading,
		isIdle: isIdle,
		currentOffice,
		offices,
	}
}

export const OFFER_TYPE_DISPLAY = {
	short_lease: 'Flexibelt avtal',
	serviced: 'Full service',
}

export function useDefaultOffice(
	officeFromUrl: string | undefined,
	offices: FlexOfficeResult[] | undefined
): FlexOfficeResult | undefined {
	if (offices === undefined || !offices.length) {
		return
	}
	if (officeFromUrl) {
		return offices?.find((o) => o.id === officeFromUrl)
	}
	return offices[0]
}
